<template>
    <v-container fluid>
        <v-toolbar
        color="secondary"
        dark
        >
            <v-toolbar-title>Other {{getCategoryType}} Treatments</v-toolbar-title>
        </v-toolbar>

        <v-tabs
        v-model="tab"
        dark
        >
            <v-tab
            v-for="tab in tabs"
            :key="tab"
            >
            {{ tab }}
            </v-tab>
      </v-tabs>
  
      <v-tabs-items v-model="tab">
        <v-tab-item
          v-for="tab in tabs"
          :key="tab"
        >
          <v-card flat>
                <TreatmentListLite
                :sort="tab"
                :isPublic="true"
                :categories="getCategoryList"
                :pageSize="10"
                :uid="userDb.uid"
                currentCollectionSelected="All"></TreatmentListLite>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-container>
</template>

<script>
import TreatmentListLite from './../TreatmentList/TreatmentListLite.vue'
import TreatmentDataService from './../../../services/treatmentDataService.js'

export default {
    data () {
      return {
        loading: false,
        treatmentService: null,
        tabs: [
            "Newest",
            "Most Popular",
        ],
        tab: null
      }
    },
    props: {
        category: String,
        userDb: Object
    },
    components: {
        TreatmentListLite
    },
    computed: {
        getCategoryType(){
            return this.category;
        },
        getCategoryList(){
            return [this.category];
        }
    },
    beforeCreate() {
        this.$options.components.TreatmentListLite = require('./../TreatmentList/TreatmentListLite.vue').default
    },
    mounted(){
        this.load();
    },
    methods: {
        async load(){
            //First initialise the data service
            this.treatmentService = new TreatmentDataService(this.userDb);
        },
    },
}
</script>